module.exports = __webpack_public_path__ + "img/icon5.55a2d7ae.svg";